import { gql } from '@apollo/client';

export const GET_TRAINING_CATEGORIES = gql(/* GraphQL */ `
    query GetTrainingCategories {
        trainingCategories {
            id
            name
            description
            sortOrder
            audiences
            createdAt
            updatedAt
        }
    }
`);

export const GET_TRAINING_MATERIALS = gql(/* GraphQL */ `
    query GetTrainingMaterials($categoryId: Int) {
        trainingMaterials(categoryId: $categoryId) {
            id
            title
            description
            s3Key
            fileName
            fileSize
            fileType
            thumbnailS3Key
            thumbnailUrl
            categoryId
            category {
                id
                name
                audiences
            }
            uploadedById
            uploadedBy {
                id
                firstName
                lastName
            }
            createdAt
            updatedAt
        }
    }
`);

export const GET_TRAINING_MATERIAL_VIEW_URL = gql(/* GraphQL */ `
    query GetTrainingMaterialViewUrl($id: Int!) {
        getTrainingMaterialViewUrl(id: $id) {
            url
        }
    }
`);

export const GET_TRAINING_MATERIAL_DOWNLOAD_URL = gql(/* GraphQL */ `
    query GetTrainingMaterialDownloadUrl($id: Int!) {
        getTrainingMaterialDownloadUrl(id: $id) {
            url
        }
    }
`);
